import React from 'react';
import styled from 'styled-components';
import { useTranslate, useWidgetsTheme } from '@src/core/hooks';

import { BodyLarge } from '@src/fonts/typography/Typography';
import { DarkTextColor } from '@src/fonts/typography/TypographyColors';
import { GradientButton } from '@src/components/reusable';
import BigCheck from '@src/components/reusable/success/BigCheck';
import { useAddToCartStatus } from '@src/domains/products/hooks/useAddToCartStatus';

const ProductAdderStatus = () => {
  const { i18n } = useTranslate();
  const actionColor = useWidgetsTheme('actionColor');

  const { status, errorMessages, openCart, tryAgain } = useAddToCartStatus();

  return (
    <>
      {status ? (
        <SuccessContainer>
          <BigCheck />
          <StatusMessage>{i18n('adder_productAddedToCart')}</StatusMessage>
          <CartAnchor href='#' onClick={openCart}>
            {i18n('adder_seeCart')}
          </CartAnchor>
        </SuccessContainer>
      ) : null}

      {!status && !!errorMessages.length ? (
        <div>
          <StatusMessage>{i18n('adder_productNotAddedToCart')}</StatusMessage>
          {errorMessages.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
          <br />
          <GradientButton actionColor={actionColor} onClick={tryAgain}>
            {i18n('adder_tryAgain')}
          </GradientButton>
        </div>
      ) : null}
    </>
  );
};

const SuccessContainer = styled.div`
  text-align: center;
`;

const StatusMessage = styled.p`
  ${BodyLarge}
  ${DarkTextColor}
    margin: 16px auto;
`;

const CartAnchor = styled.a``;

export default ProductAdderStatus;
